<a class="dropdown-item pointer" (click)="clearCache($event)">{{
  '::ClearCache' | abpLocalization
}}</a>
